import { useQuery } from '@tanstack/react-query';
import Site from 'es/app/business-logic/domain-models/Site';
import { QUERY_KEY } from 'es/app/business-logic/queryKey';
import {
    fetchAccessGroupsForCompany,
    fetchAccessGroupsForFacility,
    fetchAccessGroupsGlobal,
} from 'es/app/business-logic/services/security/fetchAccessGroups';
import { useCallback } from 'react';

export function useAccessGroups(site?: Site) {
    // Decide the fetch based on the current site
    const fetchAccessGroups = useCallback(() => {
        if (!site) return;

        if (site === Site.Global) {
            return fetchAccessGroupsGlobal();
        }

        if (site.facilityAlias === Site.GlobalAlias) {
            return fetchAccessGroupsForCompany(site.companyAlias);
        }

        return fetchAccessGroupsForFacility(site.companyAlias, site.facilityAlias);
    }, [site]);

    const { data = [], isFetching } = useQuery({
        queryKey: [QUERY_KEY.accessGroups, site?.companyAlias, site?.facilityAlias],
        queryFn: fetchAccessGroups,
        enabled: !!site,
        staleTime: Infinity,
    });

    return { accessGroups: data, isFetchingAccessGroups: isFetching };
}
